import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = {
  phone: "0532 385 34 04",
  phone_link: "+905323853404",
  whatsapp: "905323853404",
  email: "info@voyacarental.com",
  address: "İstanbul",
  service_city: "İstanbul",
  working_hours: "Pazartesi–Cuma 09:00–19:00, Cumartesi 09:00–17:00, Pazar kapalı",
  instagram: "",
  facebook: "",
  hero_title: "Yolculuğun VoyaCar'la Başlasın",
  hero_subtitle: "Ekonomik, konforlu ve güvenilir araç seçenekleriyle dilediğin yere özgürce ulaş.",
  campaign_text: "",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  useEffect(() => {
    api.get("/settings").then((res) => setSettings(res.data)).catch(() => {});
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext) || { settings: DEFAULTS, setSettings: () => {} };
}
